export const DISPLAY_TYPE_VIDEO = 0;
export const DISPLAY_TYPE_IMAGE = 1;
export const DISPLAY_TYPE_TEXT = 2;

export const DISPLAY_TYPE_SOURCE = [
  { id: DISPLAY_TYPE_VIDEO, name: '動画' },
  { id: DISPLAY_TYPE_IMAGE, name: '画像' },
  { id: DISPLAY_TYPE_TEXT, name: 'テキスト' },
];
